import axios from "axios"
import { BoundariesAPIRes } from "../types/boundaries.type"

const locationApi = axios.create({
  baseURL: "https://vanitysoft-boundaries-io-v1.p.rapidapi.com/rest/v1/",
  headers: {
    "Content-Type": "application/json",

    "x-rapidapi-host": "vanitysoft-boundaries-io-v1.p.rapidapi.com",
    "x-rapidapi-key": "401cf7cfe5mshddafef155cc4beep17a551jsn75d8a171159e",
  },
})

export const getLocationFromZip = async (
  zipCode: string
): Promise<BoundariesAPIRes> => {
  const res = await locationApi.get("public/boundary/zipcode", {
    params: { zipcode: zipCode },
  })
  return res.data
}
